import React from "react";
import {useUserContext} from "../../context/UserContext";
import moment from "moment";
import {useEventContext} from "../../context/EventContext";
import {usePlayerContext} from "../../context/PlayerContext";
import {useNavigate} from "react-router-dom";
import { useStreamContext } from "../../context/StreamContext";

export default ({children}) => {
    const {participationType} = useUserContext();
    const { watchKey } = useEventContext();
    const { streams } = useStreamContext();
    const {currentEpisode, setStream} = usePlayerContext();
    const navigate = useNavigate();

    const watchStream = (stream, episode) => {
        setStream(stream, episode);
        navigate(`/event/${watchKey}/broadcast`);
    }

    return (
        <section>
            <h2>LandingPage: {participationType}</h2>

            <div>
                {streams.map((stream) => (
                    <div key={stream.id} style={{display: 'flex'}}>
                        <button onClick={() => watchStream(stream)}>{stream.description_ru}</button>
                        {stream.episode.map((episode) => (
                            <button
                                key={episode.id}
                                onClick={() => watchStream(stream, episode)}
                                style={{backgroundColor: currentEpisode === episode ? 'red' : ''}}
                            >{episode.name_ru} ({moment.unix(episode.timeStart).format('HH:mm')} - {moment.unix(episode.timeStop).format('HH:mm, DD-MM')})</button>
                        ))}
                    </div>
                ))}
            </div>

            {children}
        </section>
    );
}
